import { render, staticRenderFns } from "./StudentInformation.vue?vue&type=template&id=3eed72db&scoped=true"
import script from "./StudentInformation.vue?vue&type=script&lang=js"
export * from "./StudentInformation.vue?vue&type=script&lang=js"
import style0 from "./StudentInformation.vue?vue&type=style&index=0&id=3eed72db&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3eed72db",
  null
  
)

export default component.exports